import { render, staticRenderFns } from "./grant-charts.vue?vue&type=template&id=48c837ce"
import script from "./grant-charts.vue?vue&type=script&lang=js"
export * from "./grant-charts.vue?vue&type=script&lang=js"
import style0 from "./grant-charts.vue?vue&type=style&index=0&id=48c837ce&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports